// import React, { useCallback, useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// // import "./SendRequest.css";
// import "../Profile/SentRequest.css";
// import { viewSentInterestRequests } from "../api/api";
// import { environment } from "../../environments/environments";

// const SentRequest = ({ onRequestProcessed }) => {
//   const [allUser, setAllUser] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [currUser, setcurrUser] = useState(null);
//   const [acceptingUserId, setAcceptingUserId] = useState(null);
//   const [rejectingUserId, setRejectingUserId] = useState(null);

//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   const fetchUserData = async () => {
//     setIsLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       setcurrUser(parsedUserData);
//       const _id = parsedUserData?.id || parsedUserData?._id;

//       if (_id) {
//         const currentUser = await viewSentInterestRequests({ user_id: _id });
//         console.log("allUser-From seding Requst", currentUser);
//         setAllUser(currentUser?.sent_requests || []);
//       }
//       // alluserdata
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRequest = async (userId, isConfirmed) => {
//     isConfirmed ? setAcceptingUserId(userId) : setRejectingUserId(userId);
//     try {
//       const values = {
//         user_id: currUser.id,
//         interested_user: userId,
//         confirm: isConfirmed,
//       };
//       const response = await axios.post("/api/update-request", values);
//       if (response.data.success) {
//         Swal.fire({
//           icon: "success",
//           title: isConfirmed ? "Accepted!" : "Rejected!",
//           text: isConfirmed
//             ? "You have accepted the request."
//             : "You have rejected the request.",
//         }).then(fetchUserData);
//         if (onRequestProcessed) onRequestProcessed();
//       }
//     } catch (error) {
//       console.error("Error updating user", error);
//     } finally {
//       setAcceptingUserId(null);
//       setRejectingUserId(null);
//     }
//   };

//   return (
//     <div className="sentcontainer">
//       {isLoading ? (
//         <div className="sentloading">Loading...</div>
//       ) : allUser.length > 0 ? (
//         <div className="sentscroll-container">
//           {allUser.map((user, index) => (
//             <div key={index} className="sentbox-view">
//               <img
//                 src={
//                   user.more_images?.length &&
//                   `${environment.url}/uploads/users/${user.more_images[0]}`
//                 }
//                 alt="user"
//                 className="sentuser-image"
//               />
//               <div className="sentuser-info">
//                 <h3>{user.name}</h3>
//                 <p>Age: {user.age} Years</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="sentno-data">No Sending Requests Available</div>
//       )}
//     </div>
//   );
// };

// export default SentRequest;

// import React, { useCallback, useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import "../Profile/SentRequest.css";
// import { viewSentInterestRequests } from "../api/api";
// import { environment } from "../../environments/environments";

// const SentRequest = ({ onRequestProcessed }) => {
//   const [allUser, setAllUser] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [currUser, setcurrUser] = useState(null);
//   const [acceptingUserId, setAcceptingUserId] = useState(null);
//   const [rejectingUserId, setRejectingUserId] = useState(null);

//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   const fetchUserData = async () => {
//     setIsLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       setcurrUser(parsedUserData);
//       const _id = parsedUserData?.id || parsedUserData?._id;

//       if (_id) {
//         const currentUser = await viewSentInterestRequests({ user_id: _id });
//         console.log("allUser-From seding Requst", currentUser);
//         setAllUser(currentUser?.sent_requests || []);
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRequest = async (userId, isConfirmed) => {
//     isConfirmed ? setAcceptingUserId(userId) : setRejectingUserId(userId);
//     try {
//       const values = {
//         user_id: currUser.id,
//         interested_user: userId,
//         confirm: isConfirmed,
//       };
//       const response = await axios.post("/api/update-request", values);
//       if (response.data.success) {
//         Swal.fire({
//           icon: "success",
//           title: isConfirmed ? "Accepted!" : "Rejected!",
//           text: isConfirmed
//             ? "You have accepted the request."
//             : "You have rejected the request.",
//         }).then(fetchUserData);
//         if (onRequestProcessed) onRequestProcessed();
//       }
//     } catch (error) {
//       console.error("Error updating user", error);
//     } finally {
//       setAcceptingUserId(null);
//       setRejectingUserId(null);
//     }
//   };

//   return (
//     <div className="sentcontainer">
//       <div className="sendHeadingText">
//         <h1>Request you have Sent</h1>
//       </div>
//       <div className="sendHeadingSubText">
//         <p>
//           Lorem Ipsum is simply dummy text of the printing and typesetting
//           industry. Lorem Ipsum has been the industry's standard dummy text ever
//           since the 1500s
//         </p>
//       </div>
//       <div className="sentline"></div>
//       {isLoading ? (
//         <div className="sentloading">Loading...</div>
//       ) : allUser.length > 0 ? (
//         <div className="sentscroll-container">
//           {allUser.map((user, index) => (
//             <div key={index} className="sentbox-view">
//               <img
//                 src={
//                   user.more_images?.length &&
//                   `${environment.url}/uploads/users/${user.more_images[0]}`
//                 }
//                 alt="user"
//                 className="sentuser-image"
//               />
//               <div className="sentuser-info">
//                 <h3>{user.name}</h3>
//                 <p>{user.age} Years</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="sentno-data">No Sending Requests Available</div>
//       )}
//     </div>
//   );
// };

// export default SentRequest;

import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import { viewSentInterestRequests, cancelRequest } from "../api/api";
import { environment } from "../../environments/environments";
import "././SentRequest.css";

const SendingRequest = () => {
  const [allUser, setAllUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currUser, setCurrUser] = useState(null);
  const [rejectingUserId, setRejectingUserId] = useState(null);

  const fetchUserData = useCallback(async () => {
    setIsLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      setCurrUser(parsedUserData);
      const _id = parsedUserData?.id || parsedUserData?._id;

      if (_id) {
        const response = await viewSentInterestRequests({ user_id: _id });

        const combinedRequests = [];

        if (response?.sent_requests?.length) {
          response.sent_requests.forEach((item) => {
            combinedRequests.push({
              ...item,
              isPendingConnection: false,
            });
          });
        }

        if (response?.pending_connections?.length) {
          response.pending_connections.forEach((item) => {
            const { from_user, to_user, from, to } = item;
            if (from === _id) {
              combinedRequests.push({
                ...to_user,
                request_sent_on: item.created_at,
                status: "pending",
                isPendingConnection: true,
              });
            } else if (to === _id) {
              combinedRequests.push({
                ...from_user,
                request_sent_on: item.created_at,
                status: "pending",
                isPendingConnection: true,
              });
            }
          });
        }

        setAllUser(combinedRequests);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const handleCancel = async (id) => {
    try {
      setRejectingUserId(id);
      const values = {
        user_id: currUser?.id || currUser?._id,
        target_user: id,
      };
      const cancelResponse = await cancelRequest(values);
      Swal.fire({
        icon: cancelResponse.success ? "success" : "error",
        title: cancelResponse.success ? "Cancelled" : "Failed",
        text: cancelResponse.message,
      }).then(fetchUserData);
    } catch (error) {
      console.error("Cancel request failed:", error);
    } finally {
      setRejectingUserId(null);
    }
  };

  return (
    <div className="requestsending-container">
      {isLoading ? (
        <div className="requestloader"></div>
      ) : allUser.length > 0 ? (
        <div className="requestscroll-container">
          {allUser.map((user, index) => (
            <div className="requestuser-card" key={index}>
              <img
                className="requestprofile-img"
                src={
                  user?.pre_consent_for_displaying_images &&
                  user?.more_images?.[0]
                    ? `${environment.url}/uploads/users/${user.more_images[0]}`
                    : "/images/user-icon.png"
                }
                alt={user?.name}
              />
              <div className="requestinfo">
                <p className="requestuser-name">{user?.name}</p>
                <p className="requestuser-age">{user?.age} Years</p>
              </div>
              {user?.status === "pending" ? (
                <div className="requestcancel-button pending">
                  {rejectingUserId === (user?.id || user?._id) ? (
                    <span className="requestloader-small" />
                  ) : (
                    "Pending"
                  )}
                </div>
              ) : (
                <button
                  className="requestcancel-button"
                  onClick={() => handleCancel(user?.id || user?._id)}
                >
                  {rejectingUserId === (user?.id || user?._id)
                    ? "Cancelling..."
                    : "Cancel"}
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="requestno-data">
          <p>No Sending Requests Available</p>
        </div>
      )}
    </div>
  );
};

export default SendingRequest;
